// <vita-pdp-cta> (blocks/vita-pdp-guarantee.liquid, P4-03): the final CTA under the PDP modules.
// It is not a second add to cart: it proxies to the one <vita-buy-box> on the page.
// - mirrors the buy box's CTA label and renewal line on load and on every vita:buy-box-change, so a
//   membership CTA always carries its renewal terms (vita-compliance-copy);
// - a click calls buyBox.submit({ location }), which adds the selected option, fires
//   vita:membership_cta and opens the cart drawer. Without JS (or without a buy box) it stays a link to
//   the buy box.
// The customer video fires vita:cta_click (section pdp_video) the first time it plays.

class VitaPdpCta extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-vita-pdp-cta]');
    this.renewal = this.querySelector('[data-vita-pdp-renewal]');
    this.buyBox = document.querySelector('vita-buy-box');
    if (!this.button || !this.buyBox) return;
    this.button.addEventListener('click', this.#onClick);
    document.addEventListener('vita:buy-box-change', this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    document.removeEventListener('vita:buy-box-change', this.#sync);
  }

  #sync = () => {
    // the size buttons swap the buy box element, so look it up again
    this.buyBox = document.querySelector('vita-buy-box') || this.buyBox;
    const label = this.buyBox.querySelector('[data-vita-cta-label]')?.textContent.trim();
    const cta = this.buyBox.querySelector('[data-vita-cta-button]');
    const renewal = this.buyBox.querySelector('[data-vita-renewal]');
    if (label) this.button.textContent = label;
    if (cta?.disabled) this.button.setAttribute('aria-disabled', 'true');
    else this.button.removeAttribute('aria-disabled');
    if (this.renewal) {
      const text = renewal && !renewal.hidden ? renewal.textContent.trim() : '';
      this.renewal.textContent = text;
      this.renewal.hidden = !text;
    }
  };

  #onClick = (e) => {
    this.buyBox = document.querySelector('vita-buy-box') || this.buyBox;
    if (typeof this.buyBox?.submit !== 'function') return;
    e.preventDefault();
    if (this.button.getAttribute('aria-disabled') === 'true') return;
    this.buyBox.submit({ location: this.dataset.location || 'pdp' });
  };
}

if (!customElements.get('vita-pdp-cta')) customElements.define('vita-pdp-cta', VitaPdpCta);

for (const video of document.querySelectorAll('.vita-pdp-video video')) {
  video.addEventListener(
    'play',
    () => window.vitaTrack?.('cta_click', { section: 'pdp_video', position: 0, label: 'play' }),
    { once: true }
  );
}
